export const SKU_COLORS = {
  'black/white': undefined,
  'dark green': '#325f2e',
  'dark grey': '#606161',
  'dark wash': undefined,
  'light blue': '#7bc0ef',
  'light grey': '#d8d8d7',
  'light pink': '#ffb8df',
  'light wash': undefined,
  'lime green': '#9ecb3b',
  'medium wash': undefined,
  'off-white': '#f6f6f6',
  'rose gold': '#b76e79',
  'royal blue': '#0049ff',
  animal: undefined,
  berry: '#8f1e47',
  black: '#000',
  blue: '#3755a4',
  bronze: '#cd7f2e',
  brown: '#774d2f',
  burgundy: '#720e0e',
  clear: '#fff',
  coral: '#f05c5d',
  floral: undefined,
  fuchsia: '#ff00a4',
  gold: '#d4af37',
  green: '#53893e',
  grey: '#d8d8d7',
  ivory: '#fff',
  khaki: '#8e9f77',
  metallic: undefined,
  multi: undefined,
  navy: '#353a49',
  neutral: '#f7e7d5',
  nude: '#eee4d7',
  olive: '#515134',
  orange: '#f07d25',
  pink: '#ff78bc',
  plaid: undefined,
  print: undefined,
  purple: '#693953',
  python: undefined,
  red: '#ec1e24',
  silver: '#c0c0c0',
  stripe: undefined,
  tan: '#baa094',
  taupe: '#483c32',
  turquoise: '#1e83a8',
  universal: undefined,
  white: '#fff',
  yellow: '#ffca44'
};

export type SkuColor = keyof typeof SKU_COLORS;
